/* ANDARE A UNA PAGINA DA FUORI DEI COMPONENTI DEL ROUTER.
 *
 * La griglia delle quote e' un componente a classe, profondo cinque livelli
 * sotto le rotte, e non ha `useNavigate`. Invece di passare una funzione di
 * mano in mano per cinque componenti, chi sta dentro il router la registra
 * qui una volta (RegistraNavigate, in Main.js) e chiunque la chiama.
 *
 * Senza registrazione (un banco di prova senza router) si cambia pagina
 * per davvero: il link resta un link.
 */
let navigare = null;

export function registraNavigate(f) {
  navigare = f;
}

export function vai(indirizzo) {
  if (navigare) navigare(indirizzo);
  else if (typeof window !== 'undefined') window.location.assign(indirizzo);
}

/** L'indirizzo della pagina di una partita, dal suo numero. */
export function indirizzoEvento(numero) {
  return numero ? '/sport/evento/' + numero : '';
}
